export default {
  "b2b.uzivatele-grid-columns.jmeno.label": "Name",
  "b2b.uzivatele-grid-columns.telefon.label": "Phone",
  "b2b.uzivatele-grid-columns.email.label": "Email",
  "b2b.uzivatele-grid-columns.role.label": "Role"
};
